<div class="container-fluid">
  <div class="row g-4">
    <div class="col-12">
      <mat-card>
        <mat-card-content>

          <!-- Add Button -->
          <div *ngIf="isdateofresultList">
            <button mat-flat-button color="primary" (click)="addDateOfResult()">
             add date Of result
            </button>
          </div>

          <!-- Course Form -->
          <div *ngIf="!isdateofresultList || isEdit">
            <form [formGroup]="formGroup">
              <div class="row g-4 mt-3">
                <div class="col-12">
                  <h6 class="section-title">date of result Formation</h6>
                </div>

                 <div class="form-two-cols">
        <!-- Select Month -->
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Year</mat-label>
          <mat-select formControlName="selectedMonth">
            <mat-option *ngFor="let month of months" [value]="month.months_name">
              {{ month.months_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Year</mat-label>
          <mat-select formControlName="selectedYear">
            <mat-option *ngFor="let year of years" [value]="year.year_name">
              {{ year.year_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
                <!-- Date Picker -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Choose a date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="formGroup.get('date')?.errors?.['required']">
                      Date is required
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>

              <!-- Form Buttons -->
              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <button mat-flat-button color="primary" [disabled]="isLoading" (click)="savedateOfResult()" class="px-4 py-2">
                      {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                    <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                      RESET
                    </button>
                    <button *ngIf="isEdit || !isdateofresultList" mat-flat-button color="primary" (click)="back()" class="px-4 py-2">
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <!-- Course List Table -->
          <div *ngIf="isdateofresultList">
            <div class="sorting-table">
              <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                <!-- Dynamic Columns -->
                <ng-container *ngFor="let column of displayedColumns.cols; let i = index" [matColumnDef]="column">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ displayedColumns.label[i] | uppercase }}
                  </th>

                  <td mat-cell *matCellDef="let row; let rowIndex = index">
                    <ng-container *ngIf="column === 'sno'; else otherCols">
                      {{ currentPage + (rowIndex + 1) }}
                    </ng-container>
                       <ng-container *ngIf="column === 'date'">
                      {{ row.date | date: 'dd/MM/yyyy' }}
                    </ng-container>
                    <ng-container *ngIf="column === 'createdAt'">
                      {{ row.createdAt | date: 'dd/MM/yyyy' }}
                    </ng-container>

                    <ng-template #otherCols>
                      <ng-container *ngIf="!['createdAt','date'].includes(column)">
                        {{ row[column] }}
                      </ng-container>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="edit(row)">
                        <mat-icon>edit</mat-icon> Edit
                      </button>
                      <button mat-menu-item (click)="delete(row)">
                        <mat-icon>delete</mat-icon> Delete
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <!-- Table Header and Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns.cols.concat(['actions'])"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns.cols.concat(['actions'])"></tr>
              </table>
            </div>

            <!-- Pagination -->
            <mat-paginator
              [pageSizeOptions]="[5, 10, 15, 20]"
              [length]="pagination.length"
              [pageIndex]="pagination.page - 1"
              [pageSize]="pagination.limit"
              (page)="pageEvent($event)"
              *ngIf="pagination.length">
            </mat-paginator>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
